module.exports = __webpack_public_path__ + "static/img/决策跃迁.277aab27.png";